"use strict";

exports.__esModule = true;
exports["default"] = FooterSiteMap;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FooterSiteMap(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M497.8 351.8h-40.4v-91.3c0-6.2-4.6-11.2-10.3-11.2h-18c-.6 0-1.2.3-1.7.4-1.4-.1-2.7-.4-4.3-.4H275.3v-89.1h40.3c7.3 0 13.3-5.9 13.3-13.2V54.3c0-7.3-6-13.3-13.3-13.3H196.4c-7.3 0-13.3 5.9-13.3 13.3V147c0 7.3 6 13.2 13.3 13.2h40.3v89.1H90.3c-1.9 0-3.5.3-5.3.5-.7-.2-1.4-.5-2.2-.5h-18c-5.7 0-10.3 5-10.3 11.2v91.3H14.2C6.9 351.8 1 357.7 1 365v92.7C1 465 6.9 471 14.2 471h119.3c7.3 0 13.3-5.9 13.3-13.3V365c0-7.3-5.9-13.2-13.3-13.2H93.2v-63.9h143.4v63.9h-40.3c-7.3 0-13.3 5.9-13.3 13.2v92.7c0 7.3 6 13.3 13.3 13.3h119.3c7.3 0 13.3-5.9 13.3-13.3V365c0-7.3-6-13.2-13.3-13.2h-40.3v-63.9h143.4v63.9h-40.3c-7.3 0-13.3 5.9-13.3 13.2v92.7c0 7.3 5.9 13.3 13.3 13.3h119.3c7.3 0 13.2-5.9 13.2-13.3V365c.1-7.3-5.8-13.2-13.1-13.2z",
    fill: "#929597"
  }));
}